import { formatCommasNumber } from "@/common/util/format-number-with-commas";
import { getDefaultDiscountText } from "@/common/util/get-default-discount-text";
import { Body14Medium } from "@/components/typography/Body14Medium";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Body14Strikethrough } from "@/components/typography/Body14Strikethrough";
import EditMemoModal from "@/page/order/PartnerCreateOrder/_componant/EditMemoModal";
import { CartItemDto } from "@/types/dto/cart-item-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";
import ItemDetailCell from "../ItemDetailCell";

interface Props {
  data: CartItemDto;
  index: number;
}

export const PartnerOrderItemTableRow: React.FC<Props> = ({ data, index }) => {
  const item = data;

  return (
    <Table.Row key={item.id} className="bg-white text-semantic-text-body">
      <Table.Cell className="align-top">
        <CustomCell>
          <Body14Regular>{index + 1}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="align-top">
        <ItemDetailCell
          item={item}
          memoEditButton={<EditMemoModal index={index} />}
        />
        {/* <CustomCell>
          <Body14Regular>{item.name}</Body14Regular>
        </CustomCell> */}
      </Table.Cell>
      <Table.Cell className="align-top">
        <CustomCell>
          <Body14Regular>{item.quantity}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="align-top">
        <CustomCell>
          <Body14Medium className="text-semantic-text-body">
            {getDefaultDiscountText(item)}
          </Body14Medium>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="align-top">
        <CustomCell>
          <Body14Medium className="text-secondary-2-orange">
            {`인센티브 할인 ${item.incentiveDiscountRate}%`}
          </Body14Medium>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="align-top">
        <CustomCell className="flex gap-[12px]">
          <Body14Strikethrough className="text-semantic-text-tertiary">
            {formatCommasNumber(item.originalPrice)}
          </Body14Strikethrough>
          <Body14Medium className="text-semantic-text-body">
            {formatCommasNumber(item.totalPrice)}
          </Body14Medium>
        </CustomCell>
      </Table.Cell>
    </Table.Row>
  );
};
